import { render, staticRenderFns } from "./CustomerService.vue?vue&type=template&id=7e951e7b&scoped=true"
import script from "./CustomerService.vue?vue&type=script&lang=js"
export * from "./CustomerService.vue?vue&type=script&lang=js"
import style0 from "./CustomerService.vue?vue&type=style&index=0&id=7e951e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e951e7b",
  null
  
)

export default component.exports